import React, { Component, createContext } from 'react';
import { getBootstrap } from '../services/settingsApi';
import { appTitle as defaultTitle, portalTitle } from '../config';

export const AppSettingsContext = createContext({
  loaded: false,
  branding: {},
  theme: {},
  portal: {},
  features: {},
  payments: {},
});

export function resolveBrandingLogo(branding, colorTheme = 'light') {
  if (!branding) return null;
  if (colorTheme === 'dark') {
    return branding.logoDark || branding.logoLight || branding.logo || null;
  }
  return branding.logoLight || branding.logo || branding.logoDark || null;
}

export function resolveAppDisplayTitle(settings, fallback = defaultTitle) {
  return settings?.portal?.appTitle || settings?.branding?.companyName || fallback;
}

function resolveDocumentTitle(bootstrap) {
  const title = resolveAppDisplayTitle(bootstrap);
  return portalTitle ? `${portalTitle} | ${title}` : title;
}

function applyBootstrapToDom(bootstrap) {
  document.title = resolveDocumentTitle(bootstrap);
  if (bootstrap?.theme?.primary) {
    document.documentElement.style.setProperty('--brand-primary', bootstrap.theme.primary);
  }
  if (bootstrap?.theme?.secondary) {
    document.documentElement.style.setProperty('--brand-secondary', bootstrap.theme.secondary);
  }
  if (bootstrap?.branding?.favicon) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = bootstrap.branding.favicon;
  }
}

export class AppSettingsProvider extends Component {
  state = {
    loaded: false,
    bootstrap: {
      branding: { companyName: defaultTitle },
      theme: { primary: '#0d6efd', secondary: '#6c757d' },
      portal: { appTitle: defaultTitle },
      features: {},
      payments: {},
    },
  };

  reload = async () => {
    try {
      const bootstrap = await getBootstrap();
      applyBootstrapToDom(bootstrap);
      this.setState({ loaded: true, bootstrap });
    } catch (e) {
      console.warn('Bootstrap settings failed, using defaults', e);
    }
  };

  async componentDidMount() {
    applyBootstrapToDom(this.state.bootstrap);
    await this.reload();
  }

  render() {
    const { bootstrap, loaded } = this.state;
    return (
      <AppSettingsContext.Provider value={{ ...bootstrap, loaded, reload: this.reload }}>
        {this.props.children}
      </AppSettingsContext.Provider>
    );
  }
}

export function withAppSettings(Wrapped) {
  return function WithAppSettings(props) {
    return (
      <AppSettingsProvider>
        <Wrapped {...props} />
      </AppSettingsProvider>
    );
  };
}
